import * as S from './CaptivateAllImageModalLoader.styles';
import {
  CenteredSpaceWrap,
  SmallSectionHeader,
  FlexCentered,
} from '../../../../CommonStyleUtils/dwebCommon.styles';

const CaptivateAllImageRightLoader = () => (
  <>
    <S.CaptivateRightContainer>
      <S.CaptivateRightTopWrap>
        <S.CaptivateHotelNameLoader />
        <S.CaptivateHotelLocationLoader />
        <S.RadioButtonTabOuterWrapper>
          <S.RadioButtonTabInnerWrapper>
            <S.RadioButtonTabSelected type="radio" />
          </S.RadioButtonTabInnerWrapper>
        </S.RadioButtonTabOuterWrapper>
      </S.CaptivateRightTopWrap>
      <S.CaptivateImageCategoriesContainer>
        <S.CaptivateImageCategoriesCard>
          <CenteredSpaceWrap>
            <div>
              <S.CaptivateImageCategoryLabel></S.CaptivateImageCategoryLabel>
              <S.CaptivateTotalImages></S.CaptivateTotalImages>
            </div>
            <S.SmallImageRightDiv>
              <FlexCentered>
                <S.CaptivateCategoryAllImageOne src="https://cdn1.goibibo.com/voy_ing/t_g/35298f4c1a5611ea82f90242ac110005.jpg" />
              </FlexCentered>
            </S.SmallImageRightDiv>
          </CenteredSpaceWrap>
        </S.CaptivateImageCategoriesCard>
        <S.CaptivateImageCategoriesCard>
          <CenteredSpaceWrap>
            <div>
              <S.CaptivateImageCategoryLabel></S.CaptivateImageCategoryLabel>
              <S.CaptivateTotalImages></S.CaptivateTotalImages>
            </div>
            <S.SmallImageRightDiv>
              <FlexCentered>
                <S.CaptivateCategoryAllImageOne src="https://cdn1.goibibo.com/voy_ing/t_g/35298f4c1a5611ea82f90242ac110005.jpg" />
              </FlexCentered>
            </S.SmallImageRightDiv>
          </CenteredSpaceWrap>
        </S.CaptivateImageCategoriesCard>
        <S.CaptivateImageCategoriesCard>
          <CenteredSpaceWrap>
            <div>
              <S.CaptivateImageCategoryLabel></S.CaptivateImageCategoryLabel>
              <S.CaptivateTotalImages></S.CaptivateTotalImages>
            </div>
            <S.SmallImageRightDiv>
              <FlexCentered>
                <S.CaptivateCategoryAllImageOne src="https://cdn1.goibibo.com/voy_ing/t_g/35298f4c1a5611ea82f90242ac110005.jpg" />
              </FlexCentered>
            </S.SmallImageRightDiv>
          </CenteredSpaceWrap>
        </S.CaptivateImageCategoriesCard>
        <S.CaptivateImageCategoriesCard>
          <CenteredSpaceWrap>
            <div>
              <S.CaptivateImageCategoryLabel></S.CaptivateImageCategoryLabel>
              <S.CaptivateTotalImages></S.CaptivateTotalImages>
            </div>
            <S.SmallImageRightDiv>
              <FlexCentered>
                <S.CaptivateCategoryAllImageOne src="https://cdn1.goibibo.com/voy_ing/t_g/35298f4c1a5611ea82f90242ac110005.jpg" />
              </FlexCentered>
            </S.SmallImageRightDiv>
          </CenteredSpaceWrap>
        </S.CaptivateImageCategoriesCard>
        <S.CaptivateImageCategoriesCard>
          <CenteredSpaceWrap>
            <div>
              <S.CaptivateImageCategoryLabel></S.CaptivateImageCategoryLabel>
              <S.CaptivateTotalImages></S.CaptivateTotalImages>
            </div>
            <S.SmallImageRightDiv>
              <FlexCentered>
                <S.CaptivateCategoryAllImageOne src="https://cdn1.goibibo.com/voy_ing/t_g/35298f4c1a5611ea82f90242ac110005.jpg" />
              </FlexCentered>
            </S.SmallImageRightDiv>
          </CenteredSpaceWrap>
        </S.CaptivateImageCategoriesCard>
      </S.CaptivateImageCategoriesContainer>
    </S.CaptivateRightContainer>
  </>
);

export default CaptivateAllImageRightLoader;
